import React from 'react';
import { api } from '@unicus/react-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';

import {
  isAudio,
  isExcel,
  isImage,
  isPDF,
  isVideo
} from 'util/functions/mimeTypes';
import join from 'util/functions/join';

const getIconName = (contentType) => {
  if (isImage(contentType)) {
    return 'file-image';
  }
  if (isPDF(contentType)) {
    return 'file-pdf';
  }
  if (isExcel(contentType)) {
    return 'file-exel';
  }

  if (isVideo(contentType)) {
    return 'file-video';
  }

  if (isAudio(contentType)) {
    return 'file-audio';
  }

  return 'file-alt';
};

const SectionField = ({
  type,
  name,
  options = [],
  answer,
  attachments = [],
  ...rest
}) => {
  const handleAttachment = ({ url }) => {
    window.open(`${api.getUrlFromResource('attendances')}/${url}`, '_blank');
  };

  const render = () => {
    if (type === 'multiline') {
      return (
        <div className="gx-text-grey">
          <span>
            {answer?.split('\n').map((str) => (
              <React.Fragment key={str}>
                {str}
                <br />
              </React.Fragment>
            ))}
          </span>
        </div>
      );
    }

    if (type === 'attachment') {
      return (
        <div className="gx-attendanceupload-list">
          {attachments.map((c) => (
            <div className="gx-attendanceupload-list-card " key={c.id}>
              <div className="gx-attendanceupload-file">
                <FontAwesomeIcon
                  className="icon gx-fs-xxxl"
                  icon={['far', getIconName(c.contentType)]}
                />
                <Button
                  type="link"
                  className="gx-fs-11 ant-btn-sm"
                  onClick={() => handleAttachment(c)}
                >
                  Baixar
                </Button>
              </div>
            </div>
          ))}
        </div>
      );
    }

    if (type === 'boolean' && answer) {
      return (
        <div className="gx-text-grey">
          <span>{answer === 'true' ? 'Sim' : 'Não'}</span>
        </div>
      );
    }

    if (type === 'options') {
      return (
        <div className="gx-text-grey">
          <span>
            {join(
              options.filter((c) => c.isChecked).map((c) => c.name),
              ' e '
            )}
          </span>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="gx-mb-3">
      <div className="gx-font-weight-bold">
        <span>{name}</span>
      </div>
      {render()}
    </div>
  );
};

export default SectionField;
